/**
 * Web 端国家和城市选择 Hook
 * 使用共享的 countriesData
 */

import { useMemo } from 'react';
import { COUNTRIES_DATA, type Country } from '@cubemeet/core/modules/travel';

type WebCountry = Country & { flagUrl: string };

export const useCountriesDataWeb = (t: (key: string) => string) => {
  // 将数据转换为包含实际翻译文本的格式
  const countries: WebCountry[] = useMemo(() => {
    return COUNTRIES_DATA.map((country) => ({
      code: country.code,
      name: t(country.nameKey as any),
      flag: country.flag,
      // add CDN flag url for web to ensure consistent rendering across OSes
      flagUrl: `https://flagcdn.com/${country.code.toLowerCase()}.svg`,
      cities: country.cityKeys.map((cityKey) => t(cityKey as any)),
    }));
  }, [t]);

  const getCountryByCode = (code: string): WebCountry | undefined => {
    return countries.find((country) => country.code === code);
  };

  const searchCountries = (query: string): WebCountry[] => {
    if (!query.trim()) return countries;

    const lowerQuery = query.toLowerCase();
    return countries.filter(
      (country) =>
        country.name.toLowerCase().includes(lowerQuery) ||
        country.cities.some((city) => city.toLowerCase().includes(lowerQuery))
    );
  };

  const searchCities = (
    query: string
  ): Array<{ country: WebCountry; city: string }> => {
    if (!query.trim()) return [];

    const lowerQuery = query.toLowerCase();
    const results: Array<{ country: WebCountry; city: string }> = [];

    countries.forEach((country) => {
      country.cities.forEach((city) => {
        if (city.toLowerCase().includes(lowerQuery)) {
          results.push({ country, city });
        }
      });
    });

    return results;
  };

  return {
    countries,
    getCountryByCode,
    searchCountries,
    searchCities,
  };
};
